<template>
    <div class="mt-10 mb-12 font-medium text-xl max-w-full w-content mx-auto px-4 sm:px-0">
        <h4 class="border-b border-b-main-color">
            <slot></slot>
        </h4>
    </div>
</template>

<script>
export default {
    name: "SectionLabel"
}
</script>

<style scoped>
</style>
